import React, { useState } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';
import AnimatedSection from './AnimatedSection';

interface FAQProps {
  onOpenRegister?: () => void;
}

export default function FAQ({ onOpenRegister }: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "Comment commencer à trader avec EvolTrade ?",
      answer: "Pour débuter avec EvolTrade, il vous suffit de vous inscrire. Ensuite, vous serez invité à créer un compte de trading auprès de l’un de nos partenaires. Une fois cette étape terminée, vous recevrez un accès à notre Discord privé où vous pourrez apprendre tout ce qu’il faut savoir sur le trading. Temps estimé pour l'inscription : environ 5 minutes."
    },
    {
      question: "Quel est le capital minimum recommandé ?",
      answer: "Il est possible de commencer avec un capital de 200€. Pour une gestion optimale des risques, nous recommandons de débuter avec un montant compris entre 500€ et 1 000€. Si vous souhaitez démarrer avec moins, il est tout à fait possible d’adapter votre gestion des risques en conséquence."
    },
    {
      question: "Puis-je trader sur mobile ?",
      answer: "Absolument ! Vous pouvez trader directement depuis votre téléphone. Accédez à nos analyses via le Discord, puis copiez les valeurs dans votre application Metatrader, où que vous soyez. Nous nous engageons à vous accompagner dans vos premiers pas en trading."
    },
    {
      question: "Est-ce compliqué de copier les alertes ?",
      answer: "Pas du tout. Aucune expérience préalable n’est nécessaire. Il vous suffit de copier et coller les valeurs fournies sur votre compte de trading. Notre équipe et la communauté sont à votre disposition pour vous accompagner dans vos premiers pas et répondre à vos questions."
    },
    {
      question: "Qu'est-ce que EvolTrade y gagne ?",
      answer: "Le trading peut être une activité solitaire. Chez EvolTrade, nous croyons en l’importance d’évoluer dans un environnement convivial et de créer des liens lorsque l’on se lance. C’est pourquoi nous avons fondé cette communauté. Par ailleurs, nous recevons une commission de la part de nos courtiers partenaires pour chaque inscription via notre lien. Cela nous permet de rémunérer notre équipe tout en permettant de vous fournir un service de qualité gratuitement."
    },
    {
      question: "Peut-on rejoindre EvolTrade sans aucune connaissance en trading au préalable ?",
      answer: "Oui, bien sûr. Aucun niveau de compétence préalable n’est requis. Notre communauté est conçue pour accompagner les membres à tous les stades de leur apprentissage, avec des services adaptés au niveau de chacun."
    }
  ];
  

  return (
  <section
    id="faq"
    className="
      relative 
      overflow-hidden 
      py-24 
      bg-black 
      bg-[url('/images/arrow-2-bg.png')]
      bg-no-repeat
      bg-left-bottom
      bg-contain
    "
  >
      <div
      className="
        absolute 
        inset-0
        pointer-events-none 
        bg-gradient-to-b 
        from-black/0   /* sombre en haut */
        to-black/0     /* plus clair en bas */
      "
    />

    <div className="absolute inset-0 bg-gradient-to-b from-black to-purple-900/10" />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <AnimatedSection>
          <div className="text-center mb-16">
            <span className="text-purple-500 font-semibold text-lg mb-4 block">FAQ</span>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Questions Fréquentes
            </h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
              Tout ce que vous devez savoir pour commencer
            </p>
          </div>
        </AnimatedSection>

        <div className="space-y-4 mb-16">
          {faqs.map((faq, index) => (
            <AnimatedSection key={index}>
              <div className="relative group">
                <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-600 to-purple-800 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200" />
                <div className="relative bg-black rounded-lg border border-purple-800/50">
                  <button
                    className="w-full px-6 py-4 text-left flex justify-between items-center"
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  >
                    <span className="text-lg font-medium text-white">{faq.question}</span>
                    <ChevronDown
                      className={`w-5 h-5 text-purple-500 transition-transform ${
                        openIndex === index ? 'transform rotate-180' : ''
                      }`}
                    />
                  </button>
                  <div
                    className={`px-6 overflow-hidden transition-all duration-300 ${
                      openIndex === index ? 'max-h-48 pb-4' : 'max-h-0'
                    }`}
                  >
                    <p className="text-gray-400">{faq.answer}</p>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>

        {/* Final CTA */}
        <AnimatedSection>
          <div className="text-center">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6">
              Prêt à commencer votre voyage vers la réussite ?
            </h3>
            <button 
              onClick={onOpenRegister}
              className="group inline-flex items-center px-8 py-4 bg-gradient-to-r from-purple-600 to-purple-800 text-white text-lg font-bold rounded-full hover:from-purple-700 hover:to-purple-900 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-purple-500/25"
            >
              <span className="relative flex items-center">
                Commencer Maintenant
                <ArrowRight className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" />
              </span>
            </button>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}